var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registerAgreement"},[_c('div',{staticClass:"registerAgreement-top"},[_c('h3',[_vm._v(_vm._s(_vm.info.title))]),(_vm.info.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}}):_c('div',{staticClass:"agreement-msg"},[_vm._v("未找到信息")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }